export enum XpMarketSortType {
  XP = "xp",
  TIME = "time",
  PRICE = "price",
  ASSET_MAFIA = "assetmafia",
  ASSET_GAS = "assetgas",
}
